import React, { useReducer } from 'react';
import createStrictContext from '../../../utils/createContext';
import AccountsModule from "./AccountsModule";
import {useAppState} from "@nutastic/nutastic-react-app";
import LoginFlow from './auth/LoginFlow';

const CustomerAccountsActions = {
    UPDATE_CUSTOMER: 'UPDATE_CUSTOMER'
};

const CustomerAccountsReducer = (state, action) => {
    switch (action.type) {
        case CustomerAccountsActions.UPDATE_CUSTOMER:
            return { ...state, customer: action.customer };
        default:
            return state;
    }
};

/**
 * @typedef CustomerAccountsContext
 * @property {Object} customer - customer object
 */
const [CustomerAccountsContext, useContext] = createStrictContext({
    name: 'CustomerAccountsContext'
});

/** @type {CustomerAccountsContext} */
const moduleDefaultState = {};

const AccountsModuleProvider = ({ onReadyToClose }) => {
    const [state, dispatch] = useReducer(CustomerAccountsReducer, {
        ...moduleDefaultState
    });
    const { authState } = useAppState();
    const { isAuthenticated } = authState;

    const dispatchCalls = {};

    // noinspection JSXUnresolvedComponent
    return <CustomerAccountsContext.Provider value={ { ...state, ...dispatchCalls } }>
        { isAuthenticated ? <AccountsModule /> : <LoginFlow onComplete={onReadyToClose}  /> }
    </CustomerAccountsContext.Provider>;
};

/**
 * @returns {CustomerAccountsContext} useCustomerAccountsContext - returns state and hooks for nuMarket
 */
const useCustomerAccountsContext = () => {
    return useContext();
};

export {
    AccountsModuleProvider,
    useCustomerAccountsContext
};
